import React from 'react'

import AddNewBornPatient from 'presentation/doctor/pages/AddNewBornPatient/index'

export default function makeDoctorAddNewBornPatient() {
  return <AddNewBornPatient />
}
